var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0926 0C5.78008 0 0.646484 5.382 0.646484 12C0.646484 18.618 5.78008 24 12.0926 24C18.4052 24 23.5388 18.618 23.5388 12C23.5388 5.382 18.4052 0 12.0926 0ZM12.0926 4C13.5024 4 14.8111 4.432 15.9462 5.132L5.54353 16.038C4.87393 14.85 4.46187 13.478 4.46187 12C4.46187 7.588 7.88427 4 12.0926 4ZM12.0926 20C10.6829 20 9.37608 19.57 8.24101 18.868L18.6417 7.964C19.3133 9.152 19.7234 10.522 19.7234 12C19.7234 16.412 16.301 20 12.0926 20Z",
    fill: "#FFFFFE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/block.75d283de5a82b8c197f811311ad649cb.svg";